import { makeVar } from "@apollo/client";

export const shouldRedirectToBecomeAffiliateViewVar = makeVar(false);
